import React, { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import SmdIcon from './SmdIcon';
const SmdDialog = forwardRef(({ children, title, query, cssClass }, ref) => {
    const dialogRef = useRef(null);

    useImperativeHandle(ref, () => ({
        close() {
            dialogRef.current.close();
        },
        showModal(skipFocus) {
            dialogRef.current.showModal();
            if (!skipFocus){
                dialogRef.current.focus();
            }
        }
    }));


    return (
        <dialog ref={dialogRef} className={cssClass}>
            <SmdIcon
                onClick={() => dialogRef.current.close()}
                cssClass='close-modal'
                icon='close'
            ></SmdIcon>
            {title && (
                <p className='title'>{title}</p>
            )}
            {query && (
                <p className='query'>{query}</p>
            )}
            {children}
        </dialog>
    );
});

export default SmdDialog;